import { Download, Visibility } from '@mui/icons-material';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import FormatDate from 'utils/formatDate';

const columnShape = [
    {
        Header: 'No',
        accessor: 'number',
        maxWidth: 60,
        Cell: ({ row }) => {
            return (
                <Box sx={{ whiteSpace: 'nowrap' }}>
                    {row.original.number || '-'}
                </Box>
            );
        },
    },
    {
        Header: 'Name',
        accessor: 'user.fullName',
        Cell: ({ row }) => {
            return (
                <Box>
                    {row.original.user.fullName}
                    <Typography sx={{ color: 'text.disabled' }} variant="body2">
                        {row.original.user.email}
                    </Typography>
                </Box>
            );
        },
    },
    {
        Header: 'Title',
        accessor: 'title',
        Cell: ({ row, value }) => {
            const titleText = !value
                ? 'Untitled'
                : value.length > 50
                ? value.substring(0, 70) + '...'
                : value;

            return (
                <Box sx={{ whiteSpace: 'nowrap' }}>
                    {titleText}
                    <Typography sx={{ color: 'text.disabled' }} variant="body2">
                        {row?.original?.type?.name ?? '-'}
                    </Typography>
                </Box>
            );
        },
    },
    {
        Header: 'Date History',
        accessor: (row) => {
            const created_at = FormatDate(row.createdAt, 'dd MMM yyyy HH:mm');
            const submitted_at = row.data?.submitted_at
                ? FormatDate(row.data.submitted_at, 'dd MMM yyyy HH:mm')
                : '-';

            return (
                <Box sx={{ whiteSpace: 'nowrap' }}>
                    Created: {created_at}
                    <br />
                    Submitted: {submitted_at}
                </Box>
            );
        },
    },
    {
        Header: 'Action',
        accessor: 'id',
        Cell: ({ row, handleDownload, handleDetail }) => {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Tooltip title="View">
                        <IconButton
                            onClick={() => handleDetail(row.original)}
                            sx={{
                                color: 'text.primary',
                                fontSize: 18,
                            }}
                        >
                            <Visibility />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Download">
                        <IconButton
                            onClick={() => handleDownload(row.original)}
                            sx={{
                                color: 'text.primary',
                                fontSize: 18,
                            }}
                        >
                            <Download />
                        </IconButton>
                    </Tooltip>
                </Box>
            );
        },
    },
];
export default columnShape;
